<template>
    <a class="flex items-center gap-2 group" href="mailto:hola@latinway.co.uk">
        
        <!-- Icon -->
        <svg class="w-6 h-6 transition text-neutral-400 group-hover:text-neutral-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
            <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
        </svg>

        <!-- Text -->
        <p class="text-neutral-600 body-md group-hover:text-neutral-800 group-active:text-neutral-400">hola@latinway.co.uk</p>

    </a>
</template>

<script>
    export default {
        
        name: 'Cta-Email',
        
    };
</script>